import { render, staticRenderFns } from "./ServiceOrdersDg.vue?vue&type=template&id=99e9666e"
import script from "./ServiceOrdersDg.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersDg.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersDg.vue?vue&type=style&index=0&id=99e9666e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports